import React from 'react';
import PropTypes from 'prop-types';

import { TableWrapper } from './css';
import TableHeader from './tableHeader';
import TableBody from './tableBody';
import Pagination from './pagination';

const Table = ({
  title,
  header,
  data,
  actions,
  dataModel,
  currentPage,
  setSrtPage,
  setOrderFulfillmentPage,
  setPage,
  step,
  count,
  url,
  actionsDisplay
}) => {
  // @Todo Sorting need to be done on backend side first
  // const [sort, setSort] = useState(defaultSort);
  // const { index, dir } = sort;
  // const sortIcon = dir ? '↑' : '↓';
  // const onClick = indexNew => {
  //   const sortNew = { index: indexNew };
  //   sortNew.dir = index === indexNew ? !dir : true;
  //   setSort(sortNew);
  // };
  const keys = Object.keys(header);
  return (
    <>
      {' '}
      <div
        style={{
          backgroundColor: 'white',
          color: 'black',
          width: '85%',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      >
        <TableWrapper>
          <TableHeader
            heading={` ${title} (${count})`}
            keys={keys}
            data={header}
          />
          <TableBody
            keys={keys}
            data={data}
            actions={actions}
            dataModel={dataModel}
            currentPage={currentPage}
            step={step}
            actionsDisplay={actionsDisplay}
          />
        </TableWrapper>
      </div>
      <Pagination
        currentPage={currentPage}
        setSrtPage={setSrtPage}
        setOrderFulfillmentPage={setOrderFulfillmentPage}
        setPage={setPage}
        step={step}
        count={count}
        url={url}
      />
    </>
  );
};

Table.propTypes = {
  title: PropTypes.string.isRequired,
  header: PropTypes.objectOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  actions: PropTypes.func,
  defaultSort: PropTypes.shape({
    index: PropTypes.string,
    dir: PropTypes.bool
  }),
  dataModel: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  currentPage: PropTypes.number,
  setSrtPage: PropTypes.func,
  setOrderFulfillmentPage: PropTypes.func,
  setPage: PropTypes.func,
  step: PropTypes.number,
  count: PropTypes.number.isRequired,
  url: PropTypes.string,
  actionsDisplay: PropTypes.string
};

Table.defaultProps = {
  defaultSort: {
    index: 'first_name',
    dir: false
  },
  dataModel: {},
  currentPage: 1,
  step: 100,
  url: '',
  actions: () => {},
  actionsDisplay: 'flex'
};

export default Table;
